// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___DHKy","toggleWrap":"styles_toggleWrap__8sRpF","content":"styles_content__1KbZw","selectAreaCode":"styles_selectAreaCode__3MDD8"};